import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar';
import { DashboardIcon } from '../../assets/icons';
import { dashboardPages } from '../../data/dashboardRoutes';
import { ScreenShare } from '@mui/icons-material';

const SideBar = ({ closeSidebar, isMobile }) => {
	// Enhanced sidebar styles for better responsiveness
	const sidebarStyles = {
		'&.ps-sidebar-root': {
			border: 'none',
			width: '290px',
			minWidth: '290px',
			height: '100vh',
		},
		'& .ps-sidebar-container': {
			width: '290px',
			boxShadow: isMobile ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none',
			height: '100vh',
			overflowY: 'auto',
		},
	};

	// Enhanced menu item styles
	const menuItemStyles = {
		root: {
			fontSize: '16px',
			fontWeight: 500,
			color: '#FFF5F8',
			'& .ps-menuitem-root': {
				color: '#200407',
				'& .ps-menu-button': {
					paddingRight: '20px',
					paddingLeft: '20px',
				},
			},
		},

		SubMenuExpandIcon: {
			span: {
				width: '9px',
				height: '9px',
			},
			color: '#FFF5F8',
		},

		button: {
			height: '58px',
			margin: '2px 8px',
			borderRadius: '8px',
			transition: 'all 0.2s ease-in-out',
			[`& .dashboard-icon path`]: {
				color: 'white',
				fill: 'white',
			},
			[`&.active`]: {
				backgroundColor: '#FFDE06',
				color: '#200407',
				transform: 'translateX(-2px)',
				[`& svg path`]: {
					color: '#200407',
					fill: '#200407',
				},
				[`& span.ps-submenu-expand-icon`]: {
					color: '#200407',
				},
			},
			'&:hover': {
				backgroundColor: '#FFDE06',
				color: '#200407',
				transform: 'translateX(-2px)',
				[`& svg path`]: {
					color: '#200407',
					fill: '#200407',
				},
				[`& span.ps-submenu-expand-icon`]: {
					color: '#200407',
				},
			},
		},

		subMenuContent: ({ level }) => ({
			backgroundColor: level === 0 && '#FFF783',
			color: '#200407',
			margin: '4px 8px',
			borderRadius: '6px',
			[`&.active`]: {
				backgroundColor: '#FFDE06',
				color: '#200407',
			},
			'&:hover': {
				backgroundColor: '#FFDE06',
				color: '#200407',
			},
		}),
	};

	// Handle menu item click on mobile
	const handleMenuItemClick = () => {
		if (isMobile) {
			closeSidebar();
		}
	};

	// Generate menu items
	const pagesRoutes = dashboardPages.map((page, index) => (
		<Fragment key={page?.id}>
			{page?.subMenu ? (
				<SubMenu
					label={page?.pageTitle}
					icon={page?.icon}
					key={index}
					component={<NavLink to={`${page?.navigateTo}`} />}>
					<MenuItem
						icon={<span className='w-2 h-2 bg-black rounded-full'></span>}
						component={
							<NavLink
								to={`${page?.subMenu?.navigateTo}`}
								onClick={handleMenuItemClick}
							/>
						}>
						{page?.subMenu?.pageTitle}
					</MenuItem>
				</SubMenu>
			) : (
				<MenuItem
					key={index}
					component={
						<NavLink to={`${page?.navigateTo}`} onClick={handleMenuItemClick} />
					}
					icon={page?.icon}>
					{page?.pageTitle}
				</MenuItem>
			)}
		</Fragment>
	));

	return (
		<div className='h-full'>
			<Sidebar
				rtl={true}
				rootStyles={sidebarStyles}
				className='!h-full'
				backgroundColor='#E0A6B8'>
				{/* Sidebar Header */}
				<div className='p-4 border-b border-white/20'>
					<h2 className='text-white font-bold text-lg text-center'>
						لوحة التحكم
					</h2>
				</div>

				<Menu
					menuItemStyles={menuItemStyles}
					className='nav-bar-menu overflow-y-auto pb-20 px-2'>
					<MenuItem
						onClick={() => {
							window.open('https://act2hf-com-969951.hostingersite.com/');
							handleMenuItemClick();
						}}
						icon={<ScreenShare className='dashboard-icon' />}>
						عرض الموقع
					</MenuItem>

					<MenuItem
						component={<NavLink to='/' onClick={handleMenuItemClick} />}
						icon={<DashboardIcon className='dashboard-icon' />}>
						لوحة التحكم
					</MenuItem>

					{pagesRoutes}
				</Menu>
			</Sidebar>
		</div>
	);
};

export default SideBar;
